/**
 * De **Locatielabel** van een vestiging (ADR-0050). De API rekent hem uit over
 * alle vestigingen van de bedrijfspagina (`LocationLabelResolver`) en zet hem als
 * `label` naast `data`: "Groningen", "Moermansweg, Groningen" of
 * "Moermansweg 2, Groningen". Zo noemt "Kies je vestiging" een vestiging precies
 * zoals het intakeformulier dat doet (ClickUp 1240ccecd3v). Hier alleen het
 * lezen en de volgorde; de regel zelf staat niet in de frontend.
 *
 * Bewust zonder imports: `scripts/test-location-label.mjs` draait dit bestand
 * in een kale vm-context.
 */

/**
 * Het label, anders wat een oudere API-build al stuurde. Met een `fallback` is
 * het nooit leeg, ook niet voor een vestiging zonder adres.
 */
export function locationLabel(location, fallback = "") {
  const data = location?.data ?? {};
  return location?.label || data.name || data.city || fallback;
}

const collator = new Intl.Collator("nl", { numeric: true, sensitivity: "base" });

const text = (value) => (value == null ? "" : String(value).trim());

const sortKeys = (location) => {
  const data = location?.data ?? {};
  return [
    // De basis van het label: de naam als die er is (alleen Online), anders de plaats.
    text(data.name) || text(data.city),
    text(data.street),
    text(data.house_number) + text(data.house_number_suffix),
  ];
};

/** Op plaats, daarbinnen op straat en huisnummer (2 vóór 14); gelijk blijft op id. */
export function compareLocations(a, b) {
  const left = sortKeys(a);
  const right = sortKeys(b);
  for (let i = 0; i < left.length; i++) {
    const order = collator.compare(left[i], right[i]);
    if (order !== 0) return order;
  }

  return (Number(a?.id) || 0) - (Number(b?.id) || 0);
}
